import {
  ADD_SALES_LINE_DETAILS,
  UPDATE_SALES_LINE_DETAILS,
  GET_SALES_LINE_DETAILS,
  GET_SALES_LINE_DETAIL,
  DELETE_SALES_LINE_DETAILS,
  GET_STOCK,
  GET_SERIAL_WISE_HISTORY,
  GET_SERIAL_TO_WAREHOUS,
} from '../types';

const initialState = { list: [], single: null, stocks: [] };

const reducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case ADD_SALES_LINE_DETAILS:
      return { ...state, list: [...state.list, payload] };
    case UPDATE_SALES_LINE_DETAILS:
      return {
        ...state,
        list: state.list.map((item) =>
          item.id === payload.id ? payload : item,
        ),
      };
    case GET_SALES_LINE_DETAILS:
      return { ...state, list: payload };
    case GET_SALES_LINE_DETAIL:
      return { ...state, single: payload };
    case DELETE_SALES_LINE_DETAILS:
      return {
        ...state,
        list: state.list.filter((item) => item.id !== payload.id),
      };
    case GET_STOCK:
      return { ...state, stocks: payload };

    case GET_SERIAL_TO_WAREHOUS:
      return { ...state, serial: payload };

    case GET_SERIAL_WISE_HISTORY:
      return { ...state, serialhistory: payload };
    default:
      return state;
  }
};

export default reducer;
